<template>
    <el-dialog :title="titleName" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>
            <el-form-item label="摘要记录" :label-width="formLabelWidth" :required="true" prop="zyJl">
                <el-input v-model="form.zyJl" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="科目代码" :label-width="formLabelWidth" :required="true" prop="kmdm">
                <el-input v-model="form.kmdm" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="科目名称" :label-width="formLabelWidth" :required="true" prop="kmmc">
                <el-input v-model="form.kmmc" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="借方金额(分)" :label-width="formLabelWidth" :required="true" prop="jfje">
                <el-input v-model="form.jfje" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="贷方金额(分)" :label-width="formLabelWidth" :required="true" prop="dfje">
                <el-input v-model="form.dfje" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="排序号" :label-width="formLabelWidth" :required="true" prop="sort">
                <el-input v-model="form.sort" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                form: {
                    id: '', mbId: '', zhangTaoId: '', zyJl: '', kmdm: '', kmmc: '', jfje: '', dfje: '', sort: ''
                },
                rules: {
                    id: [{required: true, message: '请输入主键UUID', trigger: 'blur'}],
                    mbId: [{required: true, message: '请输入模版ID', trigger: 'blur'}],
                    zhangTaoId: [{required: true, message: '请输入账套ID', trigger: 'blur'}],
                    zyJl: [{required: true, message: '请输入摘要记录', trigger: 'blur'}],
                    kmdm: [{required: true, message: '请输入科目代码', trigger: 'blur'}],
                    kmmc: [{required: true, message: '请输入科目名称', trigger: 'blur'}],
                    jfje: [{required: true, message: '请输入借方金额(分)', trigger: 'blur'}],
                    dfje: [{required: true, message: '请输入贷方金额(分)', trigger: 'blur'}],
                    sort: [{required: true, message: '请输入排序号', trigger: 'blur'}]
                },
                formLabelWidth: '120px'
            };
        },
        methods: {
            int(id) {
                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.mbId = '';
                this.form.zhangTaoId = '';
                this.form.zyJl = '';
                this.form.kmdm = '';
                this.form.kmmc = '';
                this.form.jfje = '';
                this.form.dfje = '';
                this.form.sort = '';

                if (id == 'add') {
                    this.titleName = "凭证模版子表-新增";
                    this.url = "/business/fuZhuPzmbChild/save";
                } else {
                    this.titleName = "凭证模版子表-修改";
                    this.url = "/business/fuZhuPzmbChild/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/fuZhuPzmbChild/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
</style>
